import React from 'react'
import cl from './CollectingScores.module.css'
import { Box, Flex, Grid, Heading, Table, Tbody, Td, Th, Tr } from '@chakra-ui/react'
import { useScoreStore } from '../../store/scoreStore'

function CollectingScoresStatistics() {
    const stats = useScoreStore(state => state.scores?.statistics)

    return (
        <Grid className={cl.container} marginRight='auto'>
            <Heading size='md'>Статистика</Heading>
            <Flex gap='var(--default-gap)' marginRight='auto'>
                <Box className={cl.statsTableWrapper}>
                    <Table size='sm' className={cl.statsTable}>
                        <Tbody>
                            {stats?.tag_stats && stats.tag_stats.map(ts => (
                                <Tr key={ts.title}>
                                    <Th>{ts?.title}</Th>
                                    <Td>{ts?.count}</Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </Box>
                <Box className={cl.statsTableWrapper} marginBottom='auto'>
                    <Table size='sm' className={cl.statsTable}>
                        <Tbody>
                            <Tr>
                                <Th>% отписки</Th>
                                <Td>{stats?.is_contacted_percent || '-'}</Td>
                            </Tr>
                            <Tr>
                                <Th>% сбора</Th>
                                <Td>{stats?.collected_points_percent || '-'}</Td>
                            </Tr>
                        </Tbody>
                    </Table>
                </Box>
            </Flex>
        </Grid>
    )
}

export default CollectingScoresStatistics
